<template>
  <SectionBox>
    <BasicSection appearance="vacancy-description">
      <SectionTitle ref="title" title="Описание вакансии" divider />
      <FadedContent
        :show="defaultExpanded"
        collapse-title="СВЕРНУТЬ"
        expand-title="РАЗВЕРНУТЬ"
      >
        <div class="vacancy-description__text">
          <template v-if="vacancy.team">
            <h3>О компании и команде</h3>
            <StyleUgc :ugc="vacancy.team" />
          </template>

          <template v-if="vacancy.candidate">
            <h3>Ожидания от кандидата</h3>
            <StyleUgc :ugc="vacancy.candidate" />
          </template>

          <template v-if="vacancy.description">
            <h3>Условия работы</h3>
            <StyleUgc :ugc="vacancy.description" />
          </template>

          <template v-if="vacancy.bonuses">
            <h3>Бонусы</h3>
            <StyleUgc :ugc="vacancy.bonuses" />
          </template>

          <template v-if="vacancy.instructions">
            <h3>Дополнительные инструкции</h3>
            <StyleUgc :ugc="vacancy.instructions" />
          </template>
        </div>
      </FadedContent>
      <BasicSection appearance="footer">
        <OpposingItems>
          <template #left>
            <ShareButtons
              :url="vacancy.href"
              :text="vacancy.title"
            />
          </template>
          <template #right>
            <ResourceAction
              v-if="!vacancy.archived"
              :action="!updatedFavorite ? deleteFromFavoritesAction : addToFavoritesAction"
              :params="{ vacancyId: vacancy.id }"
              ref="favoritesAction"
              v-slot="{ isLoading }"
              @success="onFavoritesChangeSucccess"
            >
              <VacancyFavoriteBtn
                @change="syncFavorite"
                @update:favorite="syncFavorite"
                v-model="vacancy.favorite"
                :disabled="isLoading"
              />
            </ResourceAction>
          </template>
        </OpposingItems>
      </BasicSection>
    </BasicSection>
  </SectionBox>
</template>

<script>

  import { VacanciesFavoritesResource } from 'src/services/vacancies.js';

  import FadedContent from 'src/components/FadedContent/FadedContent.vue';
  import OpposingItems from 'src/components/OpposingItems/OpposingItems.vue';
  import ResourceAction from 'src/components/ResourceAction/ResourceAction.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import SectionTitle from 'src/components/sections/SectionTitle/SectionTitle.vue';
  import ShareButtons from 'src/components/ShareButtons/ShareButtons.vue';
  import StyleUgc from 'src/components/StyleUgc/StyleUgc.vue';
  import VacancyFavoriteBtn from 'src/components/vacancies/VacancyFavoriteBtn/VacancyFavoriteBtn.vue';

export default {
  name: 'VacancyDescription',

  components: {
    FadedContent,
    OpposingItems,
    ShareButtons,
    SectionBox,
    SectionTitle,
    BasicSection,
    StyleUgc,
    VacancyFavoriteBtn,
    ResourceAction,
  },

  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    defaultExpanded: Boolean,
    showFavorite: Boolean,
  },

  data() {
    return {
      updatedFavorite: this.vacancy.favorite,
    };
  },

  methods: {
    addToFavoritesAction: VacanciesFavoritesResource.post,
    deleteFromFavoritesAction: VacanciesFavoritesResource.delete,
    syncFavorite(value) {
      this.updatedFavorite = value;
      this.$nextTick(() => {
        this.$refs.favoritesAction.dispatch();
      });
    },
    onFavoritesChangeSucccess({ data }) {
      if (data && data.redirect) {
        window.location = data.redirect;
      }
    }
  }
}
</script>
